import { getService } from "hooks/useStartup"
import { FetchClient } from "@/core/client/fetch_client"

export async function confirmFileUpload(fileId: string) {
  const client: FetchClient = getService(FetchClient)
  const res = await client.putAsync(
    `/storage/files/${fileId}/upload_complete`,
    null,
  )
  return { code: res?.code, message: res?.message }
}
